import { AutoAwesomeRoundedSVG } from '@modules/common/components/AutoAwesomeRoundedSVG';
import { GenerateSummaryLoaderAnimatedText } from '@modules/oracle/components/GenerateSummaryLoaderAnimatedText';
import { Divider, Skeleton, Stack, Typography } from '@mui/material';

export function UserQuoteLoader() {
  return (
    <Stack spacing={1.5} sx={{ py: 1.5, px: 2.5, mb: 2, minWidth: 500 }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <AutoAwesomeRoundedSVG />
        <Typography variant="subtitle1" color="text.disabled">
          Fetching feedback
        </Typography>
      </Stack>
      <Divider />
      <Stack spacing={2} minHeight={120}>
        <GenerateSummaryLoaderAnimatedText variant="caption" />
        <Stack spacing={1}>
          <Skeleton variant="rounded" width="100%" height="10px" />
          <Skeleton variant="rounded" width="50%" height="10px" />
        </Stack>
      </Stack>
    </Stack>
  );
}
